export const BookingOrigin = {
  EVENT_DIRECT: 'EVENT_DIRECT',
  MARKETPLACE_DIRECT: 'MARKETPLACE_DIRECT',
  JOB_LISTING: 'JOB_LISTING',
} as const;
export type BookingOrigin = (typeof BookingOrigin)[keyof typeof BookingOrigin];

export const BookingState = {
  DRAFT: 'DRAFT',
  REQUESTED: 'REQUESTED',
  AWAITING_VENDOR_RESPONSE: 'AWAITING_VENDOR_RESPONSE',
  IN_NEGOTIATION: 'IN_NEGOTIATION',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  CANCELLED: 'CANCELLED',
  AWAITING_ESCROW_FUNDING: 'AWAITING_ESCROW_FUNDING',
  CONFIRMED: 'CONFIRMED',
  IN_PROGRESS: 'IN_PROGRESS',
  SERVICE_COMPLETED: 'SERVICE_COMPLETED',
  IN_DISPUTE: 'IN_DISPUTE',
  CLOSED: 'CLOSED',
  AWAITING_VENDOR_RECONFIRM: 'AWAITING_VENDOR_RECONFIRM',
} as const;
export type BookingState = (typeof BookingState)[keyof typeof BookingState];

export const JobListingState = {
  DRAFT: 'DRAFT',
  OPEN: 'OPEN',
  SUSPENDED: 'SUSPENDED',
  CLOSED: 'CLOSED',
  CANCELLED: 'CANCELLED',
} as const;
export type JobListingState = (typeof JobListingState)[keyof typeof JobListingState];

export const IoiState = {
  OPEN: 'OPEN',
  SHORTLISTED: 'SHORTLISTED',
  WITHDRAWN: 'WITHDRAWN',
  SELECTED: 'SELECTED',
  REJECTED: 'REJECTED',
  LISTING_CANCELLED: 'LISTING_CANCELLED',
} as const;
export type IoiState = (typeof IoiState)[keyof typeof IoiState];

/**
 * Enum for booking payment status.
 */
export const BookingPaymentStatus = {
  PENDING: 'PENDING',
  ESCROW_FUNDED: 'ESCROW_FUNDED',
  RELEASED: 'RELEASED',
  REFUNDED: 'REFUNDED',
  FAILED: 'FAILED',
} as const;
export type BookingPaymentStatus = (typeof BookingPaymentStatus)[keyof typeof BookingPaymentStatus];

/** Actor that may trigger a booking state transition (RBAC). */
export const BookingTransitionActor = {
  HOST: 'HOST',
  VENDOR: 'VENDOR',
  ADMIN: 'ADMIN',
  SYSTEM: 'SYSTEM',
} as const;
export type BookingTransitionActor =
  (typeof BookingTransitionActor)[keyof typeof BookingTransitionActor];

/** Canonical booking audit action names (admin dispute-evidence API). */
export const BookingAuditAction = {
  STATE_CHANGED: 'STATE_CHANGED',
  TERMS_MODIFIED: 'TERMS_MODIFIED',
  MESSAGE_SENT: 'MESSAGE_SENT',
  ATTACHMENT_ADDED: 'ATTACHMENT_ADDED',
  BOOKING_CREATED: 'BOOKING_CREATED',
  BOOKING_COMPLETED: 'BOOKING_COMPLETED',
  BOOKING_CANCELLED: 'BOOKING_CANCELLED',
  BOOKING_ACCEPTED: 'BOOKING_ACCEPTED',
  BOOKING_REJECTED: 'BOOKING_REJECTED',
} as const;
export type BookingAuditAction = (typeof BookingAuditAction)[keyof typeof BookingAuditAction];
